(function () {
  'use strict';

  // Guard: prevent multiple IIFE executions when the script tag is emitted more than once
  // (happens when product-item.liquid is rendered via {% render %} which has isolated Liquid scope,
  // so the unless-swym_wishlist_btn_assets_loaded guard doesn't deduplicate across card renders).
  if (window.SwymWishlistBtnInitialized) return;
  window.SwymWishlistBtnInitialized = true;

  var Core = window.SwymWishlistCore;
  if (!Core) return;

  var ACTIVE_CLASS = 'SwymWishlistBtn--active';
  var variantListenerBound = false;
  var inlineSizeGateListenerBound = false;
  var clickDelegationBound = false;
  var wishlistRevealFallbackTimer = null;
  /** Swym list rows; used to re-apply Active/Add state when the PDP variant (size) changes. */
  var cachedWishlistItems = null;

  function dispatchWishlistUpdated() {
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('swym:wishlist-updated', { bubbles: true }),
      );
    } catch (e) {
      /* ignore */
    }
  }

  function getSizeHintForButton(btn) {
    var wrap = btn.closest('.SwymWishlistBtn__Wrap');
    return wrap ? wrap.querySelector('.SwymWishlistBtn__SizeHint') : null;
  }

  function revealWishlistButtons() {
    if (wishlistRevealFallbackTimer !== null) {
      clearTimeout(wishlistRevealFallbackTimer);
      wishlistRevealFallbackTimer = null;
    }
    function forceVisible(el) {
      if (!el) return;
      try {
        el.style.setProperty('opacity', '1', 'important');
      } catch (e) {
        el.style.opacity = '1';
      }
    }
    document.querySelectorAll('.SwymWishlistBtn__Wrap').forEach(function (wrap) {
      wrap.classList.add('SwymWishlistBtn__Wrap--ready');
      forceVisible(wrap);
    });
    if (!document.querySelector('.SwymWishlistBtn__Wrap')) {
      getAllButtons().forEach(forceVisible);
    }
  }

  function scheduleWishlistRevealFallback(delayMs) {
    var d = typeof delayMs === 'number' ? delayMs : 4500;
    if (wishlistRevealFallbackTimer !== null) {
      clearTimeout(wishlistRevealFallbackTimer);
    }
    wishlistRevealFallbackTimer = setTimeout(function () {
      wishlistRevealFallbackTimer = null;
      revealWishlistButtons();
    }, d);
  }

  /**
   * Match PDP “Add to bag”: until ATC is enabled (size/options chosen), block wishlist add.
   * Saved (active) state stays clickable for remove.
   */
  function syncPdpWishlistGate() {
    document.querySelectorAll('.SwymWishlistBtn[data-swym-pdp-gate]').forEach(function (btn) {
      var hint = getSizeHintForButton(btn);

      function setHint(visible) {
        if (!hint) return;
        if (visible) {
          hint.classList.add('is-visible');
        } else {
          hint.classList.remove('is-visible');
        }
      }

      if (btn.classList.contains(ACTIVE_CLASS)) {
        btn.removeAttribute('disabled');
        setHint(false);
        return;
      }

      var form = btn.closest('form[action*="/cart/add"]');
      if (!form) {
        btn.removeAttribute('disabled');
        setHint(false);
        return;
      }

      var atc = form.querySelector('.ProductForm__AddToCart');
      if (!atc) {
        btn.removeAttribute('disabled');
        setHint(false);
        return;
      }

      var blocked = atc.hasAttribute('disabled');

      // For disallow_notify_me (Sold Out) products the ATC is always disabled,
      // but users should still be able to save a size. If a size radio is checked,
      // treat the gate as open so "Add to Saved" is enabled.
      if (blocked) {
        var checkedSize = form.querySelector('.InlineSizeSelector__Radio:checked');
        if (checkedSize) blocked = false;
      }

      if (blocked) {
        btn.setAttribute('disabled', 'disabled');
      } else {
        btn.removeAttribute('disabled');
      }
      setHint(blocked);
    });
  }

  function onVariantChangedForWishlist(ev) {
    var v = ev.detail && ev.detail.variant;
    if (!v || !v.id) {
      syncPdpWishlistGate();
      return;
    }
    var root = ev.target;
    var buttons = root
      ? root.querySelectorAll('.SwymWishlistBtn[data-swym-pdp-gate]')
      : null;
    if (!buttons || !buttons.length) {
      buttons = document.querySelectorAll('.SwymWishlistBtn[data-swym-pdp-gate]');
    }
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('data-swym-variant-id', String(v.id));
    }
    if (cachedWishlistItems !== null) {
      applyWishlistItemsToButtons(cachedWishlistItems);
    } else {
      syncPdpWishlistGate();
    }
  }

  function onSwymReady(callback) {
    if (window._swat) {
      callback(window._swat);
      return;
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(function (arg) {
      callback(arg || window._swat);
    });
  }

  function getAllButtons() {
    return document.querySelectorAll('.SwymWishlistBtn');
  }

  function getWishlistLabels(btn) {
    var add = btn.getAttribute('data-wishlist-label-add');
    var remove = btn.getAttribute('data-wishlist-label-remove');
    return {
      add: add && add.length ? add : 'Add to Wishlist',
      remove: remove && remove.length ? remove : 'Saved',
    };
  }

  function getButtonData(btn) {
    var vid = btn.getAttribute('data-swym-variant-id');
    var epiNum = vid == null || vid === '' ? NaN : parseInt(vid, 10);
    return {
      empi: parseInt(btn.getAttribute('data-swym-product-id'), 10),
      epi: epiNum,
      epiStr: vid == null ? '' : String(vid),
      du: window.location.origin + btn.getAttribute('data-swym-product-url'),
    };
  }

  function productHandleFromUrl(du) {
    if (!du) return '';
    var m = String(du).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  /**
   * Epi alone is not enough: Swym rows can line up with the current variant id while
   * referring to a different product (or stale du). Require empi and /products handle
   * alignment when those fields exist so one-size / default states don’t false-"Saved".
   */
  function itemMatchesPdpData(item, data) {
    if (item == null || item.epi == null || !data) return false;
    if (item.empi != null && data.empi != null) {
      var rowEmpi = Number(item.empi);
      if (!isNaN(rowEmpi) && rowEmpi !== data.empi) {
        return false;
      }
    }
    if (item.du && data.du) {
      var hItem = productHandleFromUrl(item.du);
      var hPdp = productHandleFromUrl(data.du);
      if (hItem && hPdp && hItem !== hPdp) {
        return false;
      }
    }
    return Core.wishlistEpiMatchesRow(item, data);
  }

  function applyWishlistItemsToButtons(items) {
    cachedWishlistItems = Array.isArray(items) ? items.slice(0) : [];
    getAllButtons().forEach(function (btn) {
      var labels = getWishlistLabels(btn);
      btn.classList.remove(ACTIVE_CLASS);
      btn.setAttribute('aria-label', labels.add);
      var labelEl = btn.querySelector('.SwymWishlistBtn__Label');
      if (labelEl) labelEl.textContent = labels.add;
    });

    if (!items || !items.length) {
      syncPdpWishlistGate();
      revealWishlistButtons();
      return;
    }
    if (items[0] && items[0].lid) {
      Core.rememberWishlistLid(items[0].lid);
    }

    getAllButtons().forEach(function (btn) {
      var data = getButtonData(btn);
      var inList = false;
      var j;
      for (j = 0; j < items.length; j++) {
        if (itemMatchesPdpData(items[j], data)) {
          inList = true;
          break;
        }
      }
      if (inList) {
        var labels = getWishlistLabels(btn);
        btn.classList.add(ACTIVE_CLASS);
        btn.setAttribute('aria-label', labels.remove);
        var label = btn.querySelector('.SwymWishlistBtn__Label');
        if (label) label.textContent = labels.remove;
      }
    });
    syncPdpWishlistGate();
    revealWishlistButtons();
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('swym:wishlist-count', {
          bubbles: true,
          detail: { count: cachedWishlistItems ? cachedWishlistItems.length : 0 },
        }),
      );
    } catch (e) { /* ignore */ }
  }

  function tryLegacyFetchWishlist(swat) {
    if (
      !Core.invokeFetchWishlist(
        swat,
        applyWishlistItemsToButtons,
        revealWishlistButtons,
      )
    ) {
      revealWishlistButtons();
    }
  }

  /**
   * Match swym-wishlist.js + swym-cart-saved: items may live in any list lid; a single
   * pickWishlistList miss or response.items vs response.data.items was hiding saved state on refresh.
   */
  function fetchMergedListsOrLegacy(swat) {
    if (!swat || typeof swat.fetchLists !== 'function') {
      tryLegacyFetchWishlist(swat);
      return;
    }
    try {
      swat.fetchLists({
        callbackFn: function (rawLists) {
          var lists = Core.normalizeFetchListsPayload(rawLists);
          if (!lists || !lists.length) {
            tryLegacyFetchWishlist(swat);
            return;
          }

          var withLid = lists.filter(function (l) {
            return l && l.lid;
          });
          if (!withLid.length) {
            tryLegacyFetchWishlist(swat);
            return;
          }

          withLid.sort(function (a, b) {
            return (
              (Core.isSaveForLaterList(a) ? 1 : 0) -
              (Core.isSaveForLaterList(b) ? 1 : 0)
            );
          });

          // Cache the wishlist lid now (from list metadata, not item rows)
          // so the fast fetchListDetails path works on subsequent loads.
          var wishlistMeta = null;
          for (var wi = 0; wi < withLid.length; wi++) {
            if (!Core.isSaveForLaterList(withLid[wi])) {
              wishlistMeta = withLid[wi];
              break;
            }
          }
          if (!wishlistMeta) wishlistMeta = withLid[0];
          if (wishlistMeta && wishlistMeta.lid) {
            Core.rememberWishlistLid(wishlistMeta.lid);
          }

          var merged = [];
          var i = 0;
          function step() {
            if (i >= withLid.length) {
              if (merged.length === 0) {
                tryLegacyFetchWishlist(swat);
                return;
              }
              applyWishlistItemsToButtons(
                Core.dedupeWishlistRowsKeepLast(merged),
              );
              return;
            }
            var meta = withLid[i++];
            swat.fetchListDetails(
              { lid: meta.lid },
              function (response) {
                merged = merged.concat(Core.extractListItems(response));
                step();
              },
              function () {
                step();
              },
            );
          }
          step();
        },
        errorFn: function () {
          tryLegacyFetchWishlist(swat);
        },
      });
    } catch (e) {
      tryLegacyFetchWishlist(swat);
    }
  }

  function syncButtonStates(swat) {
    if (!swat) {
      revealWishlistButtons();
      return;
    }
    if (typeof swat.fetchLists !== 'function') {
      tryLegacyFetchWishlist(swat);
      return;
    }
    var stored = Core.readStoredWishlistLid();
    if (stored && typeof swat.fetchListDetails === 'function') {
      try {
        swat.fetchListDetails(
          { lid: stored },
          function (response) {
            var items = Core.extractListItems(response);
            if (items.length > 0) {
              applyWishlistItemsToButtons(items);
              return;
            }
            fetchMergedListsOrLegacy(swat);
          },
          function () {
            fetchMergedListsOrLegacy(swat);
          },
        );
      } catch (e) {
        fetchMergedListsOrLegacy(swat);
      }
      return;
    }
    fetchMergedListsOrLegacy(swat);
  }

  function applyInactiveUi(btn) {
    var data = getButtonData(btn);
    if (cachedWishlistItems && cachedWishlistItems.length) {
      cachedWishlistItems = cachedWishlistItems.filter(function (it) {
        return !itemMatchesPdpData(it, data);
      });
    }
    var labels = getWishlistLabels(btn);
    btn.classList.remove(ACTIVE_CLASS);
    btn.setAttribute('aria-label', labels.add);
    var label = btn.querySelector('.SwymWishlistBtn__Label');
    if (label) label.textContent = labels.add;
    syncPdpWishlistGate();
  }

  function applyActiveUi(btn) {
    var data = getButtonData(btn);
    if (cachedWishlistItems === null) {
      cachedWishlistItems = [];
    }
    var already = false;
    for (var j = 0; j < cachedWishlistItems.length; j++) {
      if (itemMatchesPdpData(cachedWishlistItems[j], data)) {
        already = true;
        break;
      }
    }
    if (!already) {
      cachedWishlistItems.push({
        epi: Core.epiForSwymApi(data),
        empi: data.empi,
        du: data.du,
      });
    }
    var labels = getWishlistLabels(btn);
    btn.classList.add(ACTIVE_CLASS);
    btn.setAttribute('aria-label', labels.remove);
    var label = btn.querySelector('.SwymWishlistBtn__Label');
    if (label) label.textContent = labels.remove;
    syncPdpWishlistGate();
  }

  /** Store the wishlist lid after an add so the fast fetchListDetails path works on next load. */
  function persistWishlistLidFromSwym(swat) {
    if (!swat || typeof swat.fetchLists !== 'function') return;
    try {
      swat.fetchLists({
        callbackFn: function (rawLists) {
          var lists = Core.normalizeFetchListsPayload(rawLists);
          for (var i = 0; i < lists.length; i++) {
            if (lists[i] && lists[i].lid && !Core.isSaveForLaterList(lists[i])) {
              Core.rememberWishlistLid(lists[i].lid);
              return;
            }
          }
        },
        errorFn: function () { /* ignore */ },
      });
    } catch (e) { /* ignore */ }
  }

  /** Same list scan as mini-cart Saved “Add to bag” removal (swym-cart-saved). */
  function removeFromWishlist(swat, btn, data) {
    Core.removeVariantFromSwym(
      swat,
      data,
      function () {
        applyInactiveUi(btn);
        dispatchWishlistUpdated();
      },
      function () {
        /* silent fail */
      },
    );
  }

  function handleClick(swat, btn) {
    if (btn.disabled) {
      return;
    }
    var data = getButtonData(btn);
    var isActive = btn.classList.contains(ACTIVE_CLASS);

    if (isActive) {
      removeFromWishlist(swat, btn, data);
    } else {
      swat.addToWishList(
        { epi: Core.epiForSwymApi(data), empi: data.empi, du: data.du },
        function () {
          applyActiveUi(btn);
          persistWishlistLidFromSwym(swat);
          dispatchWishlistUpdated();
        },
        function () {
          // silent fail
        },
      );
    }
  }

  function init(swat) {
    if (!variantListenerBound) {
      variantListenerBound = true;
      document.addEventListener('variant:changed', onVariantChangedForWishlist);
    }
    if (!inlineSizeGateListenerBound) {
      inlineSizeGateListenerBound = true;
      document.addEventListener(
        'change',
        function (ev) {
          var t = ev.target;
          if (!t || !t.classList || !t.classList.contains('InlineSizeSelector__Radio')) {
            return;
          }
          if (document.querySelector('.SwymWishlistBtn[data-swym-pdp-gate]')) {
            setTimeout(syncPdpWishlistGate, 0);
          }
        },
        true,
      );
    }

    scheduleWishlistRevealFallback(5000);
    syncButtonStates(swat);
    syncPdpWishlistGate();
    setTimeout(syncPdpWishlistGate, 0);
    setTimeout(syncPdpWishlistGate, 450);

    if (!clickDelegationBound) {
      clickDelegationBound = true;
      // Event delegation: one handler covers all current and future .SwymWishlistBtn elements,
      // which is essential because product cards can render after init() fires.
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.SwymWishlistBtn');
        if (!btn) return;
        e.preventDefault();
        handleClick(swat, btn);
      });
    }
  }

  onSwymReady(init);
})();
